import { AsyncPipe, NgTemplateOutlet, SlicePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { I18nModule, provideConfig, StateTransferType } from '@spartacus/core';
import { MediaModule, OutletPosition, provideOutlet } from '@spartacus/storefront';

import { DpNewsListComponent } from './news-list.component';
import { DpCarouselSwitcherComponent } from '@app/ui-components/carousel-switcher';

import * as loadNewsListEffect from './store/effects';
import { DP_NEWS_LIST_FEATURE } from './store/news-list-state.type';
import { newsListReducers } from './store/news-list.reducers';
import { DpNewsCarouselItemComponent } from '../news-carousel/news-carousel-item';

@NgModule({
  imports: [
    I18nModule,
    MediaModule,
    AsyncPipe,
    RouterLink,
    DpCarouselSwitcherComponent,
    NgTemplateOutlet,
    DpNewsCarouselItemComponent,
    StoreModule.forFeature(DP_NEWS_LIST_FEATURE, newsListReducers),
    EffectsModule.forFeature(loadNewsListEffect),
    SlicePipe
  ],
  providers: [
    provideOutlet({
      id: 'NewsOverviewComponent',
      position: OutletPosition.REPLACE,
      component: DpNewsListComponent
    }),
    provideConfig({ state: { ssrTransfer: { keys: { [DP_NEWS_LIST_FEATURE]: StateTransferType.TRANSFER_STATE } } } })
  ],
  declarations: [DpNewsListComponent],
  exports: [DpNewsListComponent]
})
export class DpNewsListModule {}
